<div class="fiat-investment-popup">
  <div class="close" (click)="closeDialog(); $event.stopPropagation()">
    <img src="assets/icons/news/close.svg" alt="close modal" />
  </div>
  <div class="form-container">
    <div class="header">
      <p class="title">Balance {{ selectedCoin }}</p>
      <div class="buttons">
        <button (click)="selectedSection = 0" class="btn-show-chart">
          <img
            src="/assets/icons/news/{{ selectedSection === 0 ? 'chart-selected' : 'chart' }}.svg"
            alt="chart-icon"
          />
        </button>
        <button (click)="selectedSection = 1" class="btn-show-info">
          <img
            src="/assets/icons/news/{{ selectedSection === 1 ? 'info-selected' : 'info' }}.svg"
            alt="info-icon"
          />
        </button>
      </div>
    </div>
    <div class="balance">
      <div class="invested">
        <p class="title">Invertido</p>
        <p class="ars-amount">{{ totalInvested | currency: selectedCoin }}</p>
        <p class="aust-amount">={{ totalAustEquivalent | currency: 'aUST' }}</p>
      </div>
      <div class="etimated-earns">
        <p class="percent">{{ (estimatedProfitsPercent | formatNumber: [2, 2]) || 0 }}%</p>
        <p class="description">Rendimiento anual estimado en UST</p>
      </div>
    </div>
    <div class="selector-container">
      <div class="choice">
        <div class="circle" [class.isBuying]="stakingOperation === 0"></div>
        <div
          class="pill"
          [ngClass]="{ active: stakingOperation === 0 }"
          (click)="stakingOperation = 0; srcCoin = currencyTicker; destCoin = 'AUST'"
        >
          <p [class.active]="stakingOperation === 0">Invertir</p>
        </div>
        <div
          class="pill"
          [ngClass]="{ active: stakingOperation === 1 }"
          (click)="stakingOperation = 1; srcCoin = 'AUST'; destCoin = currencyTicker"
        >
          <p [class.active]="stakingOperation === 1">Retirar</p>
        </div>
      </div>
    </div>
    <form class="form">
      <div class="input-section">
        <h3 class="subtitle">
          Cantidad {{ selectedCoin }}
          <!-- {{ stakingOperation === 0 ? 'Cantidad ' + selectedCoin : 'Cantidad aUST' }} -->
        </h3>
        <div class="field">
          <input
            type="text"
            placeholder="0,000000"
            [formControl]="quantity"
            mask="separator.2"
            thousandSeparator="."
            (keyup.enter)="swapBtnClicked()"
          />
          <span class="max-text" (click)="setMaxAmount()"> MAX </span>
        </div>
        <p class="available">
          Disponible:
          {{ (stakingOperation === 0 ? totalFiatBalance : totalInvested) | currency: selectedCoin }}
        </p>
      </div>
      <button
        [disabled]="!quantity.value || quantity.value == 0"
        (click)="swapBtnClicked()"
        class="td-btn primary"
      >
        {{ stakingOperation ? 'Retirar' : 'Invertir' }}
      </button>
    </form>
  </div>
  <div class="chart-info-container">
    <div *ngIf="selectedSection == 0" class="chart" [class.no-chart]="chartIsEmpty()">
      <div class="stats">
        <h1 class="title">Rendimiento</h1>
        <div class="profits">
          <p class="number">
            ${{ fiatProfits | formatCoinAmount: selectedCoin }}
            <!-- ${{ austProfit?.gain | formatCoinAmount: selectedCoin }} -->
            <!-- {{ selectedCoin }} -->
          </p>
          <p class="description">Ganancia obtenida hasta el momento</p>
          <p *ngIf="currencyTicker === 'ARS'" class="disclaimer">
            Rendimientos obtenidos en UST expresados en pesos
          </p>
        </div>
        <div class="chart" *ngIf="!chartIsEmpty()">
          <div class="chart-container">
            <button (click)="setSelectedMonth(selectedMonth - 1)" class="btn-prev">
              <img src="/assets/icons/news/back-arrow.svg" alt="" />
            </button>
            <ngx-charts-bar-vertical
              [scheme]="colorScheme"
              [results]="chartData"
              [xAxis]="showXAxis"
              [yAxis]="showYAxis"
              style="fill: #e5e7ee"
              [maxXAxisTickLength]="8"
            >
            </ngx-charts-bar-vertical>
            <button (click)="setSelectedMonth(selectedMonth + 1)" class="btn-next">
              <img src="/assets/icons/news/back-arrow.svg" alt="" />
            </button>
          </div>
        </div>
        <div class="chart-text" *ngIf="!chartIsEmpty()">
          <p *ngFor="let date of dates">
            {{ date }}
          </p>
        </div>
      </div>
    </div>
    <div *ngIf="selectedSection == 1" class="info">
      <label class="title">Sobre aUST</label>
      <label class="description"
        ><b>Anchor protocol</b> es un protocolo descentralizado de ahorro donde se obtienen
        rendimientos en monedas estables a través del aUST.</label
      >
      <div class="procedures">
        <div class="procedure">
          <p class="number">1</p>
          <img src="/assets/icons/news/investment-procedure-1.svg" alt="" />
          <p class="description">
            Despositá tus {{ currencyTicker === 'ARS' ? 'pesos' : 'dólares' }}
          </p>
        </div>
        <div class="procedure">
          <p class="number">2</p>
          <img src="/assets/icons/news/investment-procedure-2.svg" alt="" />
          <p class="description">Ingresá la cantidad que querés poner a rendir</p>
        </div>
        <div class="procedure">
          <p class="number">3</p>
          <img src="/assets/icons/news/investment-procedure-3.svg" alt="" />
          <p class="description">
            Se compran automáticamente aUST del protocolo Anchor y con eso, podés disfrutar los
            rendimientos día a día
          </p>
        </div>
      </div>
    </div>
  </div>
</div>
